
import { theme } from '@/config/styles'
import { FooterConfiguration } from '@/config/variables'
import { defineComponent } from 'vue-demi'

const __default__ = defineComponent({
    name: 'TheFooter',
    setup() {
        return {
            theme,
            FooterConfiguration,
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b0978ae6": (_ctx.theme.colors.black),
  "ae4b1292": (_ctx.theme.colors.white)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__